import { useLocalStorage } from "@/composables";

export const UnauthorizedGuard = () => {
  const tokenStorage = useLocalStorage("tms_token");
  if (tokenStorage.get() != null) {
    return { name: "dashboard" };
  }
  return true;
};
